// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { LazyImageStyle } from "@eisinc/MobiusOverrides/LazyImage";
import { categoryDetailSubCategoriesStyles } from "@eisinc/Overrides/Widgets/Category/CategoryDetailSubCategories";
import { fontConfig } from "@eisinc/XDL/PreStyle/typography";
import { ellipsis, xScreen } from "@eisinc/XDL/Utilities";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

categoryDetailSubCategoriesStyles.categoryImage = {
    css: css`
        img {
            object-fit: contain;
            aspect-ratio: 148 / 120;
            max-width: 100%;
            max-height: 100%;
        }
        &:hover {
            opacity: 0.33;
        }
    `,
};

categoryDetailSubCategoriesStyles.innerContainer = {
    css: css`
        display: flex;
        justify-content: flex-start;
        align-items: center;
        position: relative;
    `,
    // using ul as the wrapper to enhance accessibility
    offsetProps: {
        as: "ul",
    },
};

categoryDetailSubCategoriesStyles.wrapperCategoryLink = {
    css: css`
        width: 100%;
        display: block;

        &:focus {
            outline: 0;
        }
    `,
};
categoryDetailSubCategoriesStyles.categoryImageWrapper = {
    css: css`
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: flex-start;
        margin-bottom: 12px;
        ${LazyImageStyle} {
            width: 100%;
        }
    `,
};

categoryDetailSubCategoriesStyles.categoryText = {
    ...fontConfig.singleLineRegular,
    weight: fontConfig.weight.medium,
    css: css`
        display: block;
        margin-bottom: 0;
        width: 100%;
        text-align: center;

        &:focus {
            outline: 0;
        }

        ${ellipsis(2)}

        &:hover,
            &:focus ${/* sc-selector */ TypographyStyle} {
            text-decoration: underline;
        }

        ${xScreen("lte", "md")} {
            ${ellipsis(3)}
        }
    `,
};
